module.exports = __webpack_public_path__ + "img/monOE.0f52926b.png";